import axios from "axios";

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    timeout: 30000, //10000,
    headers: {
        "Content-Type": "application/json",
    },
});

// Attach token to every request
axiosInstance.interceptors.request.use(config => {
    const token = localStorage.getItem("Token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Handle 401 errors globally
axiosInstance.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            // localStorage.removeItem("Token");
            // localStorage.removeItem("UserId");
            // window.location.href = "/";

            // Clear all auth data
            localStorage.clear();
            sessionStorage.clear();

            // Store redirect path for after login
            sessionStorage.setItem('redirectAfterLogin', window.location.pathname);

            // Use React Router navigation instead of hard redirect
            // (requires passing navigate function or using event bus)
            window.dispatchEvent(new CustomEvent('auth:logout', {
                detail: { reason: 'Session expired' }
            }));
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
